import * as React from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import styles from './styles.module.scss';

export interface IErrorPageProps {
  title?: React.ReactNode;
  subTitle: React.ReactNode;
  description: React.ReactNode;
  imageMobile: string;
  imageTablet: string;
  imageDesktop: string;
  slotAddOn?: React.ReactNode;
}

const ErrorPage: React.FunctionComponent<IErrorPageProps> = (props) => {
  return (
    <div className={classNames(styles['error-page'])}>
      {props.title && <div className={classNames(styles['error-page__title'])}>{props.title}</div>}
      <div className={classNames(styles['error-page__texts'])}>
        <div className={classNames(styles['error-page__texts__inner'])}>
          <div className={classNames(styles['error-page__sub-title'])}>{props.subTitle}</div>
          <div className={classNames(styles['error-page__description'])}>{props.description}</div>
        </div>
      </div>
      {props.slotAddOn && (
        <div className={classNames(styles['error-page__addon'])}>
          <div className={classNames(styles['error-page__addon__inner'])}>{props.slotAddOn}</div>
        </div>
      )}
      <div className={classNames(styles['error-page__images'])}>
        <Image
          alt=""
          className={classNames(styles['mobile'])}
          src={props.imageMobile}
          fill={false}
          width={780}
          height={1144}
        />
        <Image
          alt=""
          className={classNames(styles['tablet'])}
          src={props.imageTablet}
          fill={true}
          sizes="100vw"
        />
        <Image
          alt=""
          className={classNames(styles['desktop'])}
          src={props.imageDesktop}
          fill={true}
          sizes="100vw"
        />
      </div>
    </div>
  );
};

ErrorPage.displayName = 'ErrorPage';

export default ErrorPage;
